export const searchBarButtonDisabled = () => {
    const searchBars = document.querySelectorAll('.search-bar')
    if (searchBars.length) {
        searchBars.forEach((searchBar) => {
            const input = searchBar.querySelector('input')
            const button = searchBar.querySelector('button')

            input.addEventListener('input', () => {
                if (input.value) {
                    button.disabled = false
                } else {
                    button.disabled = true
                }
            })

            if (input.value) {
                button.disabled = false
            } else {
                button.disabled = true
            }
        })
    }
}
